'use es6';

import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getUpgradableModulesWithPQL } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getSelectedUpgradableModulePQL } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { setSelectedUpgradableModule } from 'ContentEditorUI/redux/actions/appActions';
import { jsx as _jsx } from "react/jsx-runtime";
const PQLDispatcher = ({
  pqlId
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal(pqlId);
  const selectedUpgradableModule = useSelector(getSelectedUpgradableModulePQL);
  const dispatch = useDispatch();
  useEffect(() => {
    if (selectedUpgradableModule === pqlId) {
      openUpgradeModal();
      dispatch(setSelectedUpgradableModule(null));
    }
  }, [selectedUpgradableModule, pqlId, openUpgradeModal, dispatch]);
  return null;
};
export default function UpgradableModulePqls() {
  const upgradableModules = useSelector(getUpgradableModulesWithPQL);
  if (upgradableModules.length === 0) {
    return null;
  }
  return upgradableModules.map((upgradableModule, i) => /*#__PURE__*/_jsx(PQLDispatcher, {
    pqlId: upgradableModule.pqlId
  }, i));
}